/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuInputRangeCurrency_searchBrowse = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuInputRangeCurrency_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_searchBrowse",
      "args": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
